export enum ENotificationType {
  NEW_USER_TO_PROJECT = 'new_user_to_project',
  NEW_EMPLOYEE_TO_COMPANY = 'new_employee_to_company',
  ASSIGNED_TO_NEW_PROJECT = 'assigned_to_new_project',
  REMOVED_FROM_PROJECT = 'removed_from_project',
  ASSIGNED_TO_NEW_DEPARTMENT = 'assigned_to_new_department',
  VACATION_REQUEST_RESPONSE = 'vacation_request_response',
  NEW_VACATION_REQUEST = 'new_vacation_request',
  PROJECT_FINISHED = 'project_finished',
  PROJECT_CANCELED = 'project_canceled',
  NOT_FINISHED_ATTENDANCE = 'not_finished_attendance',
}
